export default {
	title: '🧔‍♂️ Máté Borkesz - Portfolio 💾',
	ogTitle: '🧔‍♂️ Máté Borkesz - Portfolio 💾',

	description: '🧔‍♂️ Máté Borkesz - Portfolio 💾 description',
	ogDescription: '🧔‍♂️ Máté Borkesz - Portfolio 💾 description',

	ogImage: window.location.origin + '/share.jpg',
};
